






import { Component, Vue } from 'vue-property-decorator'

import AppTemplate from '@/components/templates/App.vue'
import DefaultTemplate from '@/components/templates/Default.vue'
import PlainTemplate from '@/components/templates/Plain.vue'
import { mock } from '@/tools'
import { security } from '@/store/modules/security'
import { notifications } from '@/store/modules/notifications'
import { support } from '@/store/modules/support'

@Component({
  components: { AppTemplate, PlainTemplate, DefaultTemplate },
})
class App extends Vue {
  securityModule = security.context(this.$store)
  notificationsModule = notifications.context(this.$store)
  supportModule = support.context(this.$store)

  async created() {
    await this.supportModule.actions.getPhone().catch(mock)
  }
}
export default App
